import React from 'react';
import strings from 'strings';
import FPFormStatus from 'UI/components/molecules/FPFormStatus';

import {
  DataSheetCardHeading,
  DataSheetSection,
  DataSheetTitle
} from '../CandidateOverview.styled';

import EditCandidateDataSheetButton from './EditCandidateDataSheetButton';

const candidateDataSheetCopies = strings.candidates.profile.dataSheet;

/**
 * @param {Object} props
 * @param {(Object|null)} props.progress
 * @param {Function} props.onWriteUpClick
 * @param {Function} [props.onEditClick]
 */
const DataSheetWrapper = ({ progress, onWriteUpClick, onEditClick }) => {
  return (
    <DataSheetSection>
      <div>
        <DataSheetCardHeading>
          <DataSheetTitle variant="h4">{candidateDataSheetCopies.title}</DataSheetTitle>
          {progress && (
            <FPFormStatus
              status={progress.key}
              totalQuestions={progress.total}
              totalAnsweredQuestions={progress.current}
            />
          )}
        </DataSheetCardHeading>
      </div>
      {onEditClick && (
        <EditCandidateDataSheetButton
          onWriteUpClick={onWriteUpClick}
          onEditPersonalData={onEditClick}
          text={strings.shared.ui.edit}
        />
      )}
    </DataSheetSection>
  );
};

export default DataSheetWrapper;
